/**
 * Static-translations for hu. Generated from:
 *  - `online/lang/static-translations.ts` (legacy, via KEY_MAP)
 *  - `tools/sdk-translations.mjs` (SDK-specific strings)
 *
 * Do not edit by hand — changes are lost on the next `node tools/gen-locales.mjs`.
 * To fix a translation, edit legacy/sdk-translations.mjs and regenerate.
 */
const hu = {
  'anon.heading_default': 'Folytatás vendégként',
  'anon.try_again': 'Próbálja újra',
  'auth.back_to_login': 'Vissza a bejelentkezéshez',
  'auth.check_email_message': 'Nézze meg az e-mailjeit — küldtünk egy megerősítő kódot.',
  'auth.check_email_title': 'Ellenőrizze az e-mailjét',
  'auth.confirm_email_title': 'Erősítse meg e-mail-címét',
  'auth.confirmation_code': 'Megerősítő kód',
  'auth.continue_with_apple': 'Folytatás Apple-lel',
  'auth.continue_with_facebook': 'Folytatás Facebookkal',
  'auth.continue_with_github': 'Folytatás GitHubbal',
  'auth.continue_with_google': 'Folytatás Google-lel',
  'auth.create_account': 'Fiók létrehozása',
  'auth.default_subtitle': 'Jelentkezzen be az összes funkcióhoz való hozzáféréshez és az adatok szinkronizálásához.',
  'auth.email': 'E-mail cím',
  'auth.email_already_registered': 'Ez az e-mail már regisztrálva van. Jelentkezzen be alább a jelszavával vagy azzal a fiókkal, amellyel regisztrált.',
  'auth.email_exists': 'Ezzel az e-mail-címmel már létezik fiók.',
  'auth.email_not_confirmed': 'Először erősítse meg az e-mail-címét.',
  'auth.forgot_password': 'Elfelejtette a jelszavát?',
  'auth.forgot_password_title': 'Elfelejtette a jelszavát?',
  'auth.forgot_subtitle': 'Adja meg az e-mail címét és küldünk egy jelszó-visszaállító linket.',
  'auth.generic_error': 'Valami hiba történt',
  'auth.have_account': 'Van már fiókja?',
  'auth.hide_password': 'Jelszó elrejtése',
  'auth.identity_already_linked': 'Ez a fiók már regisztrálva van. Jelentkezzen be vele alább.',
  'auth.invalid_credentials': 'Érvénytelen e-mail vagy jelszó',
  'auth.invalid_otp': 'A kód érvénytelen vagy lejárt.',
  'auth.last_used': 'Legutóbb · {email}',
  'auth.last_used_no_email': 'Legutóbb',
  'auth.link_purchase_subheading': 'A vásárlást a fiókjához kapcsoljuk, hogy megőrizze a hozzáférést.',
  'auth.log_in': 'Bejelentkezés',
  'auth.log_in_link': 'Bejelentkezés',
  'auth.login_continue_purchase': 'Jelentkezzen be a vásárlás folytatásához',
  'auth.network_error': 'Hálózati hiba. Ellenőrizze a kapcsolatot és próbálja újra.',
  'auth.no_account': 'Nincs még fiókja?',
  'auth.or': 'vagy',
  'auth.password': 'Jelszó',
  'auth.passwords_mismatch': 'A jelszavak nem egyeznek',
  'auth.rate_limited': 'Túl sok kérés. Próbálja meg később.',
  'auth.repeat_password': 'Jelszó megerősítése',
  'auth.reset_link_valid': 'A link 1 órán át érvényes.',
  'auth.reset_password_title': 'Jelszó visszaállítása',
  'auth.reset_sent_message': 'Ha ez az e-mail létezik, elküldtük a visszaállító kódot.',
  'auth.reset_sent_subtitle': 'Elküldtük a jelszó-visszaállító linket. Kövesse az e-mailben található utasításokat.',
  'auth.restore_purchases_heading': 'Vásárlások visszaállítása',
  'auth.restore_purchases_subheading': 'Jelentkezzen be a vásárlásai visszaállításához.',
  'auth.send_reset': 'Visszaállító e-mail küldése',
  'auth.service_unavailable': 'A szolgáltatás ideiglenesen nem érhető el. Próbálja később.',
  'auth.show_password': 'Jelszó megjelenítése',
  'auth.sign_out': 'Kijelentkezés',
  'auth.sign_up': 'Regisztráció',
  'auth.sign_up_link': 'Regisztráció',
  'auth.signed_in': 'Bejelentkezve',
  'auth.signin_failed': 'A bejelentkezés sikertelen',
  'auth.signup_failed': 'A regisztráció sikertelen',
  'auth.verify': 'Megerősítés',
  'auth.weak_password': 'A jelszó túl gyenge.',
  'auth.welcome': 'Üdvözöljük!',
  'auth.welcome_signup': 'Üdvözöljük!',
  'cta.close': 'Bezárás',
  'cta.continue': 'Folytatás',
  'cta.get_lifetime_access': 'Élethosszig tartó hozzáférés',
  'cta.get_plan_daily': 'Napi csomag választása',
  'cta.get_plan_monthly': 'Havi csomag választása',
  'cta.get_plan_weekly': 'Heti csomag választása',
  'cta.get_plan_yearly': 'Éves csomag választása',
  'cta.start_trial': '{days} napos ingyenes próba indítása',
  'modal.close_aria': 'Bezárás',
  'modal.continue': 'Folytatás',
  'modal.error_generic': 'Valami hiba történt',
  'modal.loading': 'Betöltés…',
  'modal.purchase_restored_subtitle': 'Minden készen áll — jó használatot!',
  'modal.purchase_restored_title': 'Üdvözöljük újra',
  'modal.purchase_success_subtitle': 'Minden készen áll — jó használatot!',
  'modal.purchase_success_title': 'Fizetés beérkezett',
  'modal.verifying_subscription': 'Előfizetés ellenőrzése…',
  'nav.back': '← Vissza',
  'nav.back_aria': 'Vissza',
  'offer.limited_time': 'Időszakos ajánlat',
  'payment.awaiting_title': 'Fejezze be a fizetést az új lapon',
  'payment.checking': 'Ellenőrzés…',
  'payment.ive_paid': 'Fizettem',
  'payment.open_checkout_again': 'Pénztár újra megnyitása',
  'payment.open_checkout_button': 'Pénztár megnyitása',
  'pricing.free_trial_days': '{days} napos ingyenes próbaverzió',
  'pricing.included_per': 'Tartalmazza {interval}:',
  'pricing.interval.day': 'nap',
  'pricing.interval.lifetime_short': 'élethosszig',
  'pricing.interval.month': 'hónap',
  'pricing.interval.period': 'időszak',
  'pricing.interval.week': 'hét',
  'pricing.interval.year': 'év',
  'pricing.money_back': '30 napos pénzvisszafizetési garancia',
  'pricing.most_popular': 'Legnépszerűbb',
  'pricing.no_prices': 'Nincsenek elérhető árak.',
  'pricing.plan_label.daily': 'NAPI CSOMAG',
  'pricing.plan_label.lifetime': 'élethosszig',
  'pricing.plan_label.monthly': 'havi csomag',
  'pricing.plan_label.weekly': 'heti csomag',
  'pricing.plan_label.yearly': 'éves csomag',
  'pricing.plans_aria': 'Csomagok',
  'session.contact_support': 'Támogatás',
  'session.restore_purchases': 'Vásárlások visszaállítása',
  'session.sign_out': 'Kijelentkezés',
  'session.signed_in_as_prefix': 'Bejelentkezve mint',
  'session.signing_out': 'Kijelentkezés…',
  'support.attachments_label': 'Mellékletek',
  'support.close_button': 'Bezárás',
  'support.done_button': 'Kész',
  'support.email_placeholder': 'Adja meg az e-mail címét',
  'support.heading': 'Támogatás',
  'support.instruction': 'Kérjük, töltse ki az alábbi űrlapot a támogatási kérés elküldéséhez.',
  'support.invalid_email': 'Érvénytelen e-mail',
  'support.message_length': '1–5000 karakter',
  'support.message_placeholder': 'Adja meg az üzenetet',
  'support.required': 'Kötelező',
  'support.send_another': 'Újabb kérés küldése',
  'support.send_button': 'Küldés',
  'support.sending': 'Küldés…',
  'support.subject_length': '3–200 karakter',
  'support.subject_placeholder': 'Adja meg a tárgyat',
  'support.success_heading': 'Kérés elküldve',
  'support.success_message_prefix': 'Megkaptuk az üzenetét és válaszolunk a következő címre:'
} as const;

export default hu;
